import melat from "assets/images/mellat.png";
import saderat from "assets/images/Saderat.png";
import logoGM from "assets/images/sitelogo.svg";
import "./CartModal.scss";
import { createPortal } from "react-dom";
import ShoppingListItem from "./ShopingListItem";
import { useState, useEffect, useContext } from "react";
import CartItemsContext from "context/CardItems";
import { NavLink } from "react-router-dom";
import sendRequest2 from "hooks/useAxios2";
import { sendRequestAPI2 } from "hooks/useAxios";
import sendRequest from "hooks/useAxios";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import zarinpal from "assets/images/zarinpal.png";
import { Navigate } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { FcHighPriority } from "react-icons/fc";
import { addCommas } from "@persian-tools/persian-tools";
import toastFunction from "utils/toast";
export default function CartModal({
  inventoryWallets,
  setInvenoryWallets,
  findWallet,
}) {
  const [show, setShow] = useState(false);
  const [itemsBusiness, setItemsBusiness] = useState([]);
  const [shippingCost, setShippingCost] = useState();
  // const [inventoryWallets, setInvenoryWallets] = useState([]);
  const { items, setItems, editCartItems, updateCartItemsFunc, length } =
    useContext(CartItemsContext);

  const auth = useContext(WithAuthentication);

  const phoneNumberValidation = (mobile) => {
    return /^09\d{9}$/.test(mobile);
  };
  const patternPostalCode = /^\d{10}$/;

  // پيدا کردن هزينه ارسال يا بيشترين هزينه ارسال
  const shippingCalculation = (array) => {
    let max = 1;
    return max;
  };

  //search for business id in every product
  useEffect(() => {
    // const getCarditemsBaseOnBusiness = (items) => {
    // [
    //   {business:{},items:[{},{},{}]},
    //   {business:{},items:[{},{},{}]}
    //   ]
    //search for business id in every product

    let itemsBaseOnBusiness = [];

    for (let i = 0; i < items.length; i++) {
      let index = itemsBaseOnBusiness.findIndex(
        (value) => value.business.id === items[i].business_info.id
      );
      // if (items[i].price_info[0].submit_price > maxSubmit) {
      //   maxSubmit = parseInt(items[i].price_info[0].submit_price);
      // }
      console.log("index", index);
      if (items[i].price_info[0].submit_price) {
        if (index !== -1 && itemsBaseOnBusiness.length > 0) {
          // if it exist,just add it
          // itemsBaseOnBusiness[index].items.push({
          //   ...items[i],
          //   maxSubmit: ,
          // });
          itemsBaseOnBusiness[index] = {
            ...itemsBaseOnBusiness[index],
            items: [...itemsBaseOnBusiness[index].items, items[i]],
            maxSubmit:
              items[i].price_info[0].submit_price >
              itemsBaseOnBusiness[index].maxSubmit
                ? items[i].price_info[0].submit_price
                : itemsBaseOnBusiness[index].maxSubmit,
          };
        } else {
          //if it dosn't exist,create new item
          itemsBaseOnBusiness.push({
            business: items[i].business_info,
            items: [items[i]],
            maxSubmit: items[i].price_info[0].submit_price,
          });
        }
      } else {
        if (index !== -1 && itemsBaseOnBusiness.length > 0) {
          // if it exist,just add it
          // itemsBaseOnBusiness[index].items.push({
          //   ...items[i],
          //   maxSubmit: ,
          // });
          itemsBaseOnBusiness[index] = {
            ...itemsBaseOnBusiness[index],
            items: [...itemsBaseOnBusiness[index].items, items[i]],
            maxSubmit:
              items[i].price_info[0].submit_price_group >
              itemsBaseOnBusiness[index].maxSubmit
                ? items[i].price_info[0].submit_price_group
                : itemsBaseOnBusiness[index].maxSubmit,
          };
        } else {
          //if it dosn't exist,create new item
          itemsBaseOnBusiness.push({
            business: items[i].business_info,
            items: [items[i]],
            maxSubmit: items[i].price_info[0].submit_price_group,
          });
        }
      }
    }
    setItemsBusiness([...itemsBaseOnBusiness]);
    console.log("gg", itemsBaseOnBusiness);
    // };
  }, [items]);

  // SubmitCost
  const getTotalSubmitPrice = () => {
    let number = 0;
    for (let index = 0; index < itemsBusiness?.length; index++) {
      number += parseInt(itemsBusiness[index].maxSubmit);
      console.log("num", number);
    }
    return number;
  };

  console.log("getTotalSubmitPrice", getTotalSubmitPrice());

  console.log("00", itemsBusiness);
  // console.log("itemcccccc", itemCategory);
  console
    .log
    // "items:",
    // items,
    // "getCarditemsBaseOnBusiness:"
    // getCarditemsBaseOnBusiness(items)
    // getShippingPrice(getCarditemsBaseOnBusiness(items))
    ();
  // console.log("itemsBaseOnBusiness@@", itemsBusiness);

  // const hi = getShippingPrice(itemsBaseOnBusiness);
  // console.log("hi", hi);
  // console.log("itemsBusiness", itemsBusiness);
  // const highestPrice = shippingCalculation(items);
  const ValidationInfo = () => {
    let valid = true;
    if (phoneNumberValidation(addModalCart.phone)) {
      setValidateValues((prev) => {
        return { ...prev, phone: true };
      });
    } else {
      setValidateValues((prev) => {
        return { ...prev, phone: false };
      });
      valid = false;
    }

    if (addModalCart.fulName) {
      setValidateValues((prev) => {
        return { ...prev, fulName: true };
      });
    } else {
      setValidateValues((prev) => {
        return { ...prev, fulName: false };
      });
      valid = false;
    }

    if (addModalCart.city) {
      setValidateValues((prev) => {
        return { ...prev, city: true };
      });
    } else {
      setValidateValues((prev) => {
        return { ...prev, city: false };
      });
      valid = false;
    }
    if (patternPostalCode.test(addModalCart.postalCode)) {
      setValidateValues((prev) => {
        return { ...prev, postalCode: true };
      });
    } else {
      setValidateValues((prev) => {
        return { ...prev, postalCode: false };
      });
      valid = false;
    }
    if (addModalCart.address) {
      setValidateValues((prev) => {
        return { ...prev, address: true };
      });
    } else {
      setValidateValues((prev) => {
        return { ...prev, address: false };
      });
      valid = false;
    }
    return valid;
    // if (valid) {
    //   navigate("/payment", {
    //     replace: true,
    //   });
    //   setShow(false);
    // }
  };
  const [validateValues, setValidateValues] = useState({
    fulName: true,
    province: true,
    city: true,
    postalCode: true,
    address: true,
    phone: true,
    BankPortal: true,
  });
  const [addModalCart, setAddModalCart] = useState({
    fulName: "",
    province: "",
    city: "",
    postalCode: "",
    address: "",
    phone: "",
    BankPortal: "",
  });
  const changeHandler = (value, type) => {
    setAddModalCart((prev) => {
      return { ...prev, [type]: value };
    });
  };
  const navigate = useNavigate();

  // const [items, setItems] = useState([
  //   // {
  //   //   img: laptop,
  //   //   name: "لپ تاپ",
  //   //   text: "لپ تاپ 13/7 اينچي اپل",
  //   //   colorName: "مشکي",
  //   //   color: "black",
  //   //   price: 70000000,
  //   //   number: 3,
  //   //   amountDiscount: 5000000,
  //   // },
  // ]);

  const getTotalPrice = () => {
    let totalPrice = 0;
    for (let index = 0; index < items?.length; index++) {
      totalPrice += parseInt(items[index].main_price * items[index].itemcount);
    }
    return totalPrice;
  };
  console.log("getTotalPrice", getTotalPrice());
  const getTotalDiscount = () => {
    let totalDiscount = 0;
    for (let index = 0; index < items?.length; index++) {
      totalDiscount += parseInt(
        items[index].main_discount * items[index].itemcount
      );
    }
    return totalDiscount;
  };
  // const getTotalDiscount = () => {
  //   if (items.main_discount != "0" || items.main_discount != "") {
  //     let totalDiscount = 0;

  //     for (let index = 0; index < items?.length; index++) {
  //       totalDiscount += parseInt(
  //         items[index].main_discount * items[index].itemcount
  //       );
  //     }
  //     return totalDiscount;
  //   }
  // };
  const getTotalNumber = () => {
    let number = 0;
    for (let index = 0; index < items?.length; index++) {
      number += parseInt(items[index].itemcount);
    }
    return number;
  };
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [cityTag, setCityTags] = useState([]);

  const translateToReactSelectProvinceCity = (data) => {
    let after = [];
    for (let index = 0; index < data.length; index++) {
      let obj = {};
      obj.label = data[index].title;
      obj.value = data[index].id;

      if (data[index].provinceid) {
        obj.provinceid = data[index].provinceid;
      }
      after.push(obj);
    }
    return after;
  };

  // const editCartItems = async (type, productId) => {
  //   let { data } = await sendRequest("cartitem", {
  //     situation: type,
  //     productId,
  //   });
  //   return +data.status;
  // };
  const selectType = (type) => {
    switch (type) {
      case 1:
        return 0;
      case 2:
        return 2;
        defult: return null;
    }
  };
  const selectUid = (type) => {
    switch (type) {
      case 1:
        return auth.userInfo.id;
      case 2:
        return auth.userInfo.bussinesses[0]?.id;
        defult: return null;
    }
  };
  useEffect(() => {
    // sendRequest("Find_wallets", {
    //   conditions: `type/=/${selectType(
    //     auth.userInfo.userType
    //   )}@@uid/=/${selectUid(auth.userInfo.userType)}`,
    // }).then(({ data }) => {
    //   setInvenoryWallets(data[0].current_inventory);
    // });
    sendRequest("Find_provinces").then(({ data }) => {
      setProvinceOptions(translateToReactSelectProvinceCity(data));
    });
    sendRequest2("Find_cities").then(({ data }) => {
      setCityTags(translateToReactSelectProvinceCity(data));
    });
  }, []);

  let parsInventoryWallets = parseInt(inventoryWallets);
  console.log("parsInventoryWallets", parsInventoryWallets);
  const priceDifference =
    getTotalPrice() -
    getTotalDiscount() +
    getTotalSubmitPrice() -
    parsInventoryWallets;
  useEffect(() => {
    if (show === true) {
      updateCartItemsFunc();
    }
  }, [show]);
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  const sendAddCartModal = () => {
    let fd = new FormData();
    fd.append("receiver_fullname", addModalCart.fulName);
    fd.append("receiver_city_id", addModalCart.city.value);
    fd.append("receiver_postalcode", addModalCart.postalCode);
    fd.append("receiver_address", addModalCart.address);
    fd.append("receiver_mobile", addModalCart.phone);
    sendRequestAPI2("reg_order", fd).then(({ data }) => {
      // if (data.status == 1 && data.url) {
      // if (auth.userInfo.userType == 1) {
      //   navigate("customer-panel/orders");
      // } else if (auth.userInfo.userType == 2) {
      //   navigate("admin-panel/orders");
      // }
      // setShow(false);
      // toastCustome("براي تکميل خريد ابتدا حساب خود را شارژکنيد");

      // window.location.href = `${data.url}`;
      // }
      if (data.status == 1 && !data.url) {
        if (auth.userInfo.userType == 1) {
          navigate("customer-panel/orders");
          setShow(false);
          updateCartItemsFunc();
        } else if (auth.userInfo.userType == 2) {
          navigate(`shop/orders/${auth.userInfo.bussinesses[0].id}`);
          setShow(false);
          updateCartItemsFunc();
        }
      } else if (data.status == -1) {
        toastFunction("error", "درحال حاظر امکان سفارش اين محصول وجود ندارد.");

        updateCartItemsFunc();
      }
    });
  };
  const shargeWallet = () => {
    sendRequestAPI2("charge_wallet", {
      amount: priceDifference,
      token: "",
    }).then(({ data }) => {
      if (data.status == 1 && data.url) {
        setShow(false);
        window.location.href = `${data.url}`;
      }
    });
  };
  const sharzhORregorder = () => {
    if (
      ValidationInfo() &&
      parsInventoryWallets >=
        getTotalPrice() - getTotalDiscount() + getTotalSubmitPrice()
    ) {
      sendAddCartModal();
    } else if (
      parsInventoryWallets <
      getTotalPrice() - getTotalDiscount() + getTotalSubmitPrice()
    ) {
      shargeWallet();
    }
  };
  return (
    <div>
      <div
        onClick={() => {
          setShow(true);
          findWallet();

          for (let i = 0; i < items?.length; i++) {
            if (items[i].status == -2) {
              toast.error(`محصول ${items[i].title} از سبد خريد شما حذف گرديد.`);
            }
          }
        }}
      >
        {
          <span
            className="cart d-flex align-items-center justify-content-center"
            style={{ width: 15, height: 15 }}
          >
            {length}
          </span>
        }
        <FiShoppingCart />
      </div>

      <Modal
        className="CartModal"
        show={show}
        fullscreen
        onHide={() => {
          setShow(false);
        }}
      >
        <div
          // className="modal fade"
          id="CartModal"
        >
          <div
            // className="modal-dialog modal-fullscreen"
            style={{ height: "fit-content", position: "relative" }}
          >
            {/* {Object.keys(selectedItem).length && ( */}
            <Modal.Header style={{ marginLeft: "10px" }} closeButton>
              {parsInventoryWallets <
                getTotalPrice() -
                  getTotalDiscount() +
                  getTotalSubmitPrice() && (
                <div
                  className="d-flex justify-content-center "
                  style={{ marginRight: "auto" }}
                >
                  <div
                    className="row toastWallet  "
                    style={{
                      backgroundColor: "#FAEBD7",
                      borderRadius: "13px",
                      textAlign: "center",
                      color: "black",
                      padding: "10px",
                      color: "#5d616f",
                      fontSize: "15px",
                    }}
                  >
                    <p style={{ whiteSpace: "nowrap", margin: "auto" }}>
                      <FcHighPriority></FcHighPriority>
                      ابتدا موجودي حساب خود را از طريق دکمه خريد و شارژ افزايش
                      دهيد
                    </p>
                  </div>
                </div>
              )}
            </Modal.Header>
            <Modal.Body>
              <div
                // className="modal-content"
                style={{
                  backgroundColor: "#f9f7f8",
                }}
              >
                <div className=" row ">
                  <div className="col-12  col-lg-8">
                    <div style={{ marginRight: "20px", marginTop: "15px" }}>
                      {/* <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button> */}
                    </div>

                    <div className="d-flex-column mt-4">
                      <div style={{ color: "#2e2c2d", textAlign: "center" }}>
                        <p style={{ fontSize: "18px" }}> ليست خريد</p>
                      </div>
                      <div
                        style={{
                          color: "#7c87ac",
                          borderTop: "2px solid #7c87ac",
                          width: "90px",
                          margin: "auto",
                          marginBottom: "10px",
                        }}
                      ></div>
                    </div>

                    <ShoppingListItem
                      items={items}
                      setItems={setItems}
                      editCartItems={editCartItems}
                      updateCartItemsFunc={updateCartItemsFunc}
                    ></ShoppingListItem>
                  </div>
                  <div
                    className="d-flex justify-content-center col-12  col-lg-4 position-ralative"
                    style={{ backgroundColor: "#1d3a8c" }}
                  >
                    <div
                      className="d-flex-column mt-5"
                      style={{ width: "80%" }}
                    >
                      <div
                        style={{
                          color: "white",
                          width: "90px",
                          margin: "auto",
                          marginBottom: "10px",
                        }}
                      ></div>
                      <div
                        style={{
                          backgroundColor: "#f9f7f8",
                          borderRadius: "13px",
                          width: "90%",
                          textAlign: "center",
                          color: "white",
                          padding: "15px 10px",
                          fontSize: "14px",
                          marginTop: "30px",
                          margin: "auto",
                        }}
                      >
                        <div style={{ color: "black", textAlign: "center" }}>
                          <p style={{ fontSize: "18px" }}>صورت حساب</p>
                        </div>
                        <div
                          style={{
                            color: "white",
                            borderTop: "1px solid black",
                            width: "90px",
                            margin: "auto",
                            marginBottom: "10px",
                          }}
                        ></div>
                        {/* <span style={{ width: "30%", alignSelf: "center" }}>
                <span
                  style={{
                    marginRight: "10px",
                    color: "#5d616f",
                  }}
                >
                  {getTotalNumber() }
                </span>
                <span style={{ marginRight: "4px", color: "#5d616f" }}>
                  کالا
                </span>
              </span> */}

                        {/* <span
                style={{
                  marginRight: "5px",
                  marginLeft: "5px",
                  color: "#5d616f",
                }}
              >
                :
              </span>
              <span style={{ marginRight: "8px", color: "#5d616f" }}>
                {getTotalPrice().toLocaleString()}
              </span>
              <span style={{ marginRight: "10px", color: "#5d616f" }}>
                تومان
              </span> */}
                        <div style={{ marginTop: "40px" }}>
                          <span>
                            <p style={{ color: "#5d616f" }}>
                              {getTotalNumber()} کالا :
                              {addCommas(getTotalPrice())} تومان
                            </p>
                          </span>
                          <span>
                            <p style={{ color: "#e55c75" }}>
                              مجموع تخفيف : {addCommas(getTotalDiscount())}{" "}
                              تومان
                            </p>
                          </span>
                          <span>
                            <p style={{ color: "#5d616f" }}>
                              هزينه ارسال :{addCommas(getTotalSubmitPrice())}
                              تومان
                            </p>
                          </span>
                        </div>

                        {/* <div className="d-flex mt-2">
                <span style={{ color: "#e55c75", whiteSpace: "nowrap" }}>
                  {" "}
                  مجموع تخفيف{" "}
                </span>
                <span
                  style={{
                    marginRight: "5px",
                    marginLeft: "5px",
                    color: "#5d616f",
                  }}
                >
                  :
                </span>
                <span style={{ color: "#e55c75" }}>
                  {getTotalDiscount().toLocaleString()}
                </span>
                <span style={{ marginRight: "10px", color: "#e55c75" }}>
                  تومان
                </span>
              </div> */}
                      </div>
                      <div
                        style={{
                          backgroundColor: "white",
                          marginTop: "40px",
                          borderRadius: "3px",
                          width: "fitContent",
                          textAlign: "center",
                          color: "black",
                          padding: "15px 10px",
                          fontSize: "16px",
                        }}
                      >
                        اطلاعات گيرنده
                      </div>
                      <div className="box d-flex flex-wrap mt-4 align-items-baseline   ">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            // height: "50px",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                            alignSelf: "center",
                          }}
                        >
                          <label htmlFor="fulName">نام و نام خانوادگي</label>
                        </div>
                        <div
                          className="cart-modal-input"
                          //  style={{ width: "65%" }}
                        >
                          {parsInventoryWallets <
                          getTotalPrice() -
                            getTotalDiscount() +
                            getTotalSubmitPrice() ? (
                            <input
                              type="text"
                              disabled
                              className="form-control"
                              id="fulName"
                            />
                          ) : (
                            <>
                              {" "}
                              <input
                                type="text"
                                required
                                className="form-control"
                                id="fulName"
                                value={addModalCart.fulName}
                                onChange={(e) => {
                                  changeHandler(e.target.value, "fulName");
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility:
                                    validateValues.fulName == ""
                                      ? "visible"
                                      : "hidden",
                                }}
                              >
                                لطفا نام کاربر را وارد کنيد.
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <div className="box d-flex flex-wrap mt-4 align-items-baseline">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                          }}
                        >
                          <label htmlFor="province">استان</label>
                        </div>
                        <div
                          className="cart-modal-input"
                          style={{ color: "black" }}
                        >
                          <Select
                            // className="form-control form-select"
                            id="province"
                            options={provinceOptions}
                            value={addModalCart.province}
                            onChange={(e) => {
                              changeHandler(e, "province");
                              setAddModalCart((prev) => {
                                let temp = { ...prev };
                                temp.city = null;
                                return { ...temp };
                              });
                            }}
                          />
                      
                          <p
                            style={{
                              color: "red",
                              fontSize: "13px",
                              visibility:
                                validateValues.province == ""
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            لطفا استان مد نظر را انتخاب کنيد.
                          </p>
                        </div>
                      </div> */}
                      <div className="box d-flex flex-wrap mt-4 align-items-baseline">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                          }}
                        >
                          <label htmlFor="city">شهر</label>
                        </div>
                        <div className="cart-modal-input">
                          {parsInventoryWallets <
                          getTotalPrice() -
                            getTotalDiscount() +
                            getTotalSubmitPrice() ? (
                            <Select
                              // className="form-control form-select"
                              id="city"
                              isDisabled
                              options={cityTag}
                            />
                          ) : (
                            <>
                              <Select
                                // className="form-control form-select"
                                id="city"
                                options={cityTag}
                                value={addModalCart.city}
                                onChange={(e) => {
                                  changeHandler(e, "city");
                                }}
                              />

                              <p
                                style={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility:
                                    validateValues.city == ""
                                      ? "visible"
                                      : "hidden",
                                }}
                              >
                                لطفا شهرمورد نظر را وارد کنيد.
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="box d-flex flex-wrap mt-4 align-items-baseline">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                            alignSelf: "center",
                            // height: "50px",
                          }}
                        >
                          <label htmlFor="postalCode">کدپستي</label>
                        </div>
                        <div className="cart-modal-input">
                          {parsInventoryWallets <
                          getTotalPrice() -
                            getTotalDiscount() +
                            getTotalSubmitPrice() ? (
                            <input
                              type="text"
                              disabled
                              className="form-control"
                              id="postalCode"
                            />
                          ) : (
                            <>
                              {" "}
                              <input
                                type="text"
                                required
                                className="form-control"
                                id="postalCode"
                                value={addModalCart.postalCode}
                                onChange={(e) => {
                                  if (!isNaN(e.target.value))
                                    changeHandler(e.target.value, "postalCode");
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility:
                                    validateValues.postalCode == ""
                                      ? "visible"
                                      : "hidden",
                                }}
                              >
                                لطفا کد پستي خود را وارد کنيد.{" "}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="box d-flex flex-wrap mt-4 align-items-baseline">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                            alignSelf: "center",
                            // height: "50px",
                          }}
                        >
                          <label htmlFor="address">آدرس </label>
                        </div>
                        <div className="cart-modal-input">
                          {parsInventoryWallets <
                          getTotalPrice() -
                            getTotalDiscount() +
                            getTotalSubmitPrice() ? (
                            <textarea
                              type="text"
                              disabled
                              className="form-control"
                              id="address"
                            />
                          ) : (
                            <>
                              <textarea
                                type="text"
                                required
                                className="form-control"
                                id="address"
                                value={addModalCart.address}
                                onChange={(e) => {
                                  changeHandler(e.target.value, "address");
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility:
                                    validateValues.address == ""
                                      ? "visible"
                                      : "hidden",
                                }}
                              >
                                لطفا آدرس خود را وارد کنيد.
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="box d-flex flex-wrap mt-4 align-items-baseline">
                        <div
                          className="cart-modal-label"
                          style={{
                            color: "white",
                            // width: "35%",
                            whiteSpace: "nowrap",
                            textAlign: "right",
                            alignSelf: "center",
                            // height: "50px",
                          }}
                        >
                          <label htmlFor="phon">شماره تماس</label>
                        </div>

                        <div className="cart-modal-input">
                          {parsInventoryWallets <
                          getTotalPrice() -
                            getTotalDiscount() +
                            getTotalSubmitPrice() ? (
                            <>
                              <input
                                type="text"
                                name="phone"
                                disabled
                                className="form-control"
                                id="phon"
                              />
                            </>
                          ) : (
                            <>
                              <input
                                type="text"
                                name="phone"
                                required
                                className="form-control"
                                id="phon"
                                value={
                                  addModalCart.phone == undefined
                                    ? ""
                                    : addModalCart.phone
                                }
                                onChange={(e) => {
                                  if (!isNaN(e.target.value))
                                    changeHandler(e.target.value, "phone");
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "13px",
                                  visibility:
                                    validateValues.phone == ""
                                      ? "visible"
                                      : "hidden",
                                }}
                              >
                                شماره همراه وارد شده اشتباه است.
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="box-b d-flex flex-wrap mt-3 align-items-baseline">
                        <div
                          className="cart-modal-label2"
                          style={{
                            color: "white",
                            // width: "60%",
                            whiteSpace: "nowrap",
                            //textAlign: "right",
                          }}
                        >
                          <label> درگاه پرداخت</label>
                        </div>
                        <div
                          className="bank d-flex justify-content-around cart-modal-bank mt-2"
                          style={{
                            // width: "60%",
                            whiteSpace: "nowrap",
                            //textAlign: "right",
                          }}
                        >
                          <div
                            className="item-b"
                            style={{
                              borderRadius: "20px",
                              //width: "20%",
                              textAlign: "center",
                              color: "black",
                              fontSize: "14px",
                              boxShadow:
                                addModalCart.BankPortal == "melat"
                                  ? "rgb(120, 240, 240) 0px 5px 10px"
                                  : "none",
                            }}
                            value={addModalCart.BankPortal}
                            onClick={(e) => {
                              setAddModalCart((prev) => {
                                return { ...prev, BankPortal: "melat" };
                              });
                            }}
                          >
                            <img style={{ width: "50px" }} src={zarinpal}></img>
                          </div>
                          {/* <div
                            className="item-b"
                            style={{
                              backgroundColor: "white",
                              borderRadius: "3px",
                              marginRight: "20px",
                              width: "20%",
                              textAlign: "center",
                              color: "black",
                              fontSize: "14px",
                              marginRight: "10px",
                              boxShadow:
                                addModalCart.BankPortal == "saderat"
                                  ? "rgb(120, 240, 240) 0px 5px 10px"
                                  : "none",
                            }}
                            value={addModalCart.BankPortal}
                            onClick={(e) => {
                              setAddModalCart((prev) => {
                                return { ...prev, BankPortal: "saderat" };
                              });
                            }}
                          >
                            <img src={saderat}></img>
                          </div> */}
                        </div>
                      </div>
                      <div className="box row mt-5 pb-3">
                        <div
                          className="col-7 mt-2 text-light "
                          style={{ fontSize: "14px" }}
                        >
                          <span>مبلغ نهايي : </span>
                          <span>
                            {addCommas(
                              getTotalPrice() -
                                getTotalDiscount() +
                                getTotalSubmitPrice()
                            )}
                          </span>
                          <span style={{ marginRight: "10px" }}>تومان</span>
                        </div>
                        <div className=" d-flex col-5">
                          {/* <NavLink to="/payment"> */}
                          <button
                            style={{
                              backgroundColor: "#ef384f",
                              margin: " 0 auto",
                              color: "white",
                              border: "none",
                              borderRadius: "3px",
                              padding: "10px 10px ",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              sharzhORregorder();
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#CartModal"
                          >
                            {parsInventoryWallets >=
                            getTotalPrice() -
                              getTotalDiscount() +
                              getTotalSubmitPrice()
                              ? "تکميل خريد"
                              : "خريد وشارژ"}
                          </button>
                          {/* </NavLink> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>

            {/* )} */}
          </div>
        </div>
      </Modal>
    </div>
  );
  // const modalVar = (

  // );

  // return createPortal(modalVar, document.querySelector("#modals"));
}
